/**
 * Sheet component constants
 *
 * Configuration values specific to the ExpauseSheet component system.
 * These are not animations but behavioral/structural constants.
 */

export const SHEET_CONSTANTS = {
  /** Pixels to drag down before auto-dismiss (bottom sheet) */
  dismissThreshold: 150,

  /** Maximum number of stacked sheets allowed */
  maxStack: 5,

  /** Base z-index for sheets */
  baseZIndex: 100,

  /** Z-index increment per stacked sheet */
  zIndexIncrement: 10,
} as const;

export type SheetConstants = typeof SHEET_CONSTANTS;
